<template>
  <div>
    <ag-grid-vue
      ref="agIncomingPayments"
      style="height: 75vh;"
      class="ag-theme-alpine mb-5"
      v-bind="agIncomingPayments"
      @grid-ready="onGridReady"
      @cell-clicked="onCellClickedIP"
    />

    <!-- Modal to Cancel -->
    <modal :show.sync="modals.cancel" modal-classes="modal-dialog-centered modal-md" @close="closeCancel">
      <CancelIncPayment
        v-if="modals.cancel"
        :data="currentCancel"
        @close="closeCancel"
        @success="reloadTable"
      />
    </modal>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import axios from "axios";
import { AgGridVue } from "ag-grid-vue";
import { AG_GRID_LOCALE_ES } from "@ag-grid-community/locale";
import Formats from "@/mixins/Formats";
import BaseLoader from "@/components/BaseLoader.vue";
import AgIcon from "@/components/AgGrid/AgIcon.vue";
import AgBadge from "@/components/AgGrid/AgBadge.vue";
import CancelIncPayment from "./CancelIncPayment.vue";
import AgGrid from "@/mixins/AgGrid";
import FilterDate from "@/components/AgGrid/Filters/FilterDate.vue";

export default {
  name: "TableIncPayments",
  mixins: [Formats, AgGrid],
  components: {
    AgGridVue,
    BaseLoader,
    AgIcon,
    AgBadge,
    CancelIncPayment,
    agDateInput: FilterDate,

  },
  data() {
    return {
      downloadingPDF: null,
      currentCancel: null,
      modals: {
        cancel: false,
      },
      agIncomingPayments: {
        columnDefs: [
          {
            field: "DocNum",
            headerName: "# Cobro",
            sort: "desc",
            minWidth: 130,
            filter: "agTextColumnFilter",
          },
          {
            field: "DocDate",
            headerName: "Fecha",
            minWidth: 140,
            filter: "agDateColumnFilter",
            valueFormatter: ({value}) => this.dateFormat(value),
          },
          {
            field: "totalSum",
            headerName: "Cantidad",
            valueFormatter: ({data}) => this.currencyFormat(data.totalSum, data.DocCurr),
            type: "rightAligned",
            filter: "agNumberColumnFilter",
            minWidth: 140,
          },
          {
            field: "CardName",
            headerName: "Cliente",
            filter: "agTextColumnFilter",
            minWidth: 120,
            width: 450,
          },
          {
            field: "CardCode",
            headerName: "Código Cliente",
            filter: "agTextColumnFilter",
            minWidth: 120,
          },
          {
            colId: "pdf",
            headerName: "PDF",
            sortable: false,
            filter: false,
            suppressHeaderMenuButton: true,
            width: 90,
            maxWidth: 90,
            minWidth: 90,
            cellClass: ({data}) => {
              const classList = [
                "d-flex",
                "justify-content-center",
                "align-items-center",
              ];
              if (this.downloadingPDF) {
                if (this.downloadingPDF === data.DocNum) {
                  classList.push("opacity-5");
                }
              } else {
                classList.push("ag-clickable-cell");
              }
              return classList.join(" ");
            },
            cellRendererSelector: () => {
              return {
                component: "AgIcon",
                params: {
                  color: "red",
                  text: "PDF",
                  icon: "fas fa-file-pdf",
                },
              };
            },
          },
          {
            colId: "xml",
            headerName: "XML",
            sortable: false,
            filter: false,
            suppressHeaderMenuButton: true,
            width: 90,
            maxWidth: 90,
            minWidth: 90,
            cellClass: ({data}) => {
              if (data.U_WebXML || data.U_TS_ReportID) {
                return `d-flex justify-content-center align-items-center ag-clickable-cell`;
              }
            },
            cellRendererSelector: ({data}) => {
              if (data.U_WebXML || data.U_TS_ReportID) {
                return {
                  component: "AgIcon",
                  params: {
                    color: "orange",
                    text: "XML",
                    icon: "fas fa-file-code",
                  },
                };
              }
            },
          },
          {
            field: "Canceled",
            headerName: "",
            sortable: false,
            width: 110,
            filter: "agSetColumnFilter",
            filterParams:{
              values: ['N', 'Y'],
              suppressMiniFilter: true,
              suppressFloatingFilterButton: true,
              defaultToNothingSelected: true,
              valueFormatter: ({value}) => value === 'N' ? 'No cancelados' : 'Cancelados',
            },
            maxWidth: 110,
            minWidth: 110,
            valueFormatter: ({value}) => value === 'N' && 'Cancelar',
            cellClass: ({value}) => {
              if(value === 'N'){
                return 'ag-clickable-cell text-red font-weight-bold'
              }
            },
            cellRendererSelector: ({value}) => {
              if(value !== 'N'){
              return {
                component: "AgBadge",
                params: {
                  text: "Cancelado",
                  color: "#f5365c",
                },
              }
            }
            },
          },
        ],
        defaultColDef: {
          suppressHeaderMenuButton: true,
          sortable: true,
          resizable: true,
          cellDataType: false,
          filter: true,
          floatingFilter: true,
        },
        autoSizeStrategy: {
          type: 'fitGridWidth',
          defaultMinWidth: 100,
        },
        pagination: true,
        paginationPageSize: 1000,
        paginationPageSizeSelector: [100, 500, 1000, 2000],
        cacheBlockSize: 30,
        maxBlocksInCache: 10,
        rowModelType: "serverSide",
        loadingOverlayComponent: "BaseLoader",
        suppressCellFocus: true,
        enableCellTextSelection: true,
        cacheQuickFilter: true,
        localeText: AG_GRID_LOCALE_ES,
        alwaysShowVerticalScroll: true,
      },
    };
  },
  created() {
    this.HANA_URL = process.env.VUE_APP_HANA_URL;
    this.DATABASE = process.env.VUE_APP_DATABASE;
  },
  methods: {
    onGridReady({api}) {
      api.setGridOption("serverSideDatasource", this.getServerSideDatasource());
      api.setFilterModel({
        Canceled: { type: "set", values: ["N"] },
      });
    },
    onCellClickedIP(params) {
      if (params.column.colId === "pdf" && !this.downloadingPDF) {
        this.handlePDF(params);
      } else if (params.column.colId === "xml") {
        this.handleXML(params);
      } else if (params.colDef.field === "Canceled" && params.value === "N") {
        this.showCancelModal(params.data);
      }
    },
    showCancelModal(data) {
      this.modals.cancel = true;
      this.currentCancel = data;
    },
    closeCancel() {
      this.modals.cancel = false;
      this.currentCancel = null;
    },
    handlePDF({data, api}) {
      this.downloadingPDF = data.DocNum;
      api.refreshCells({ columns: ["pdf"] });
      const json = {
        DocCode: (data.U_WebXML || data.U_TS_ReportID) ? "RCT10008" : "RCT10013",
        Pairs: {
          "DocKey@": data.DocEntry,
        },
      };
      axios
        .post(`/api/pdf_file`, json)
        .then((res) => {
          if (res.data.se_err) {
            this.$swal("Error", res.data.se_err.message, "error");
          } else {
            let link = document.createElement("a");
            link.download = `Cobro_${data.DocNum}.pdf`;
            link.href = res.data.base64;
            link.click();
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.downloadingPDF = null;
          api.refreshCells({ columns: ["pdf"] });
        });
    },
    handleXML({data}) {
      const row = data;
      if (row.U_WebXML) {
        let link_xml = document.createElement("a");
        link_xml.download = `Cobro${row.DocNum}.xml`;
        link_xml.href = row.U_WebXML;
        link_xml.target = "_blank";
        document.body.appendChild(link_xml);
        link_xml.click();
        document.body.removeChild(link_xml);
      } else if (row.U_TS_ReportID) {
        const [año, mes, dia] = row.DocDate.split("-");
        const download = `https://canplast.net:50000/api/v1/sap/xml/${año}/${mes}/${dia}/${
          row.CardCode
        }/${row.CardName}/${row.U_TS_ReportID}?token=${localStorage.getItem(
          "token-cpm"
        )}`;
        window.open(download, "_blank");
      }
    },
    reloadTable(){
      this.$refs.agIncomingPayments.api.resetColumnState();
      this.$refs.agIncomingPayments.api.setGridOption("serverSideDatasource", this.getServerSideDatasource());
      this.$refs.agIncomingPayments.api.sizeColumnsToFit();
    },
    getServerSideDatasource() {
      return {
        getRows: (params) => {
          const { filterModel, endRow, startRow, sortModel } = params.request;

          //SUBQUERY
          const subQuery = `
            SELECT    
              "DocNum", 
              "DocEntry", 
              "CardCode", 
              "CardName", 
              "DocDate",
              "DocCurr", 
              "U_TS_ReportID", 
              "U_WebXML",
              "Canceled",
              CASE WHEN "DocCurr" = 'MXP' THEN
                CASE
                  WHEN "CheckSum" > 0 THEN "CheckSum" 
                  ELSE "CashSum" + "TrsfrSum"
                END
              ELSE
                CASE
                  WHEN "CheckSumFC" > 0 THEN "CheckSumFC" 
                  ELSE "CashSumFC" + "TrsfrSumFC"
                END
              END AS "totalSum"
            FROM ${this.DATABASE}."ORCT"
          `;

          //FILTERS
          let filters = ``;
          const filterModelKeys = Object.keys(filterModel);
          if (filterModelKeys.length) {
            const all = filterModelKeys.reduce((acc, key) => {
              if (filterModel[key].operator) {
                const conditionsArray = filterModel[key].conditions.map((condition) => {
                  return this.formatCondition(condition, key);
                }
              );
              const toPush = "(" + conditionsArray.join(" " + filterModel[key].operator + " ") + ")";
              acc.push(toPush);
              } else {
                const condition = this.formatCondition(filterModel[key], key);
                if(condition){
                  acc.push(condition);
                }
              }
              return acc;
            }, []);
            if(all.length){
              filters += "WHERE " + all.join(" AND ");
            }
          }

          //PAGINATION
          const pageSize = endRow - startRow;
          const pagination = `LIMIT ${pageSize} OFFSET ${startRow}`;

          //SORTING
          let sorting;
          if (sortModel.length) {
            sorting = `ORDER BY "${sortModel[0].colId}" ${sortModel[0].sort.toUpperCase()}`;
            if(sortModel[0].colId !== "DocNum"){
              sorting += `, "DocNum" DESC`;
            }
          } else {
            sorting = `ORDER BY "DocNum" DESC`;
          }

          //JSON PAYLOADS
          const rowDataJson = {
            query: `
              SELECT *
              FROM (${subQuery})
              ${filters}
              ${sorting}
              ${pagination}
            `
          };
          const totalsJson = {
            query: `
              SELECT COUNT(*) AS "rowCount"
              FROM (${subQuery})
              ${filters}
            `
          };

          // console.log("🟦rowDataJson", rowDataJson.query);
          // console.log("🟦totalsJson", totalsJson.query);
          
          axios
            .all([
              axios.post(`${this.HANA_URL}/api/hana/freedom`, rowDataJson),
              axios.post(`${this.HANA_URL}/api/hana/freedom`, totalsJson),
            ])
            .then(
              axios.spread((rowDataRes, totalsRes) => {
                // console.log("🟪 DATA", rowDataRes.data.length);
                // console.log("🟪 TOTALS", totalsRes.data);
                params.success({
                  rowData: rowDataRes.data,
                  rowCount: totalsRes.data[0].rowCount,
                });
                
              })
            )
            .catch((err) => {
              console.error(err);
              params.fail();
            });
        },
      };
    },

  },
};
</script>

<style lang="scss">
.ag-clickable-cell {
  cursor: pointer;
}
.ag-clickable-cell:hover {
  background: #e9ecef;
}
</style>
